/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UploadCustomsDocsReminderEmailDefaultContent
 */
export interface UploadCustomsDocsReminderEmailDefaultContent {
  /**
   *
   * @type {string}
   * @memberof UploadCustomsDocsReminderEmailDefaultContent
   */
  subject: string;
  /**
   *
   * @type {string}
   * @memberof UploadCustomsDocsReminderEmailDefaultContent
   */
  body: string;
}

/**
 * Check if a given object implements the UploadCustomsDocsReminderEmailDefaultContent interface.
 */
export function instanceOfUploadCustomsDocsReminderEmailDefaultContent(
  value: object,
): value is UploadCustomsDocsReminderEmailDefaultContent {
  if (!("subject" in value) || value["subject"] === undefined) return false;
  if (!("body" in value) || value["body"] === undefined) return false;
  return true;
}

export function UploadCustomsDocsReminderEmailDefaultContentFromJSON(
  json: any,
): UploadCustomsDocsReminderEmailDefaultContent {
  return UploadCustomsDocsReminderEmailDefaultContentFromJSONTyped(json, false);
}

export function UploadCustomsDocsReminderEmailDefaultContentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UploadCustomsDocsReminderEmailDefaultContent {
  if (json == null) {
    return json;
  }
  return {
    subject: json["subject"],
    body: json["body"],
  };
}

export function UploadCustomsDocsReminderEmailDefaultContentToJSON(
  json: any,
): UploadCustomsDocsReminderEmailDefaultContent {
  return UploadCustomsDocsReminderEmailDefaultContentToJSONTyped(json, false);
}

export function UploadCustomsDocsReminderEmailDefaultContentToJSONTyped(
  value?: UploadCustomsDocsReminderEmailDefaultContent | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    subject: value["subject"],
    body: value["body"],
  };
}
